import React from "react";
import MessageBubble from "./MessageBubble";

const ConversationPanel = ({
  selectedConversation, reply, setReply, sending, updatingStatus,
  handleSendReply, handleUpdateStatus, messagesEndRef, formatDateTime,
}) => {
  const unreadUserMessages = selectedConversation?.messages?.filter(
    (msg) => msg.senderRole === "user" && !msg.isRead
  ) || [];

  return (
    <section className="xl:col-span-8">
      <div className="flex h-[760px] flex-col overflow-hidden rounded-3xl border border-slate-800 bg-slate-900 shadow-sm">
        {selectedConversation ? (
          <>
            <div className="border-b border-slate-800 px-6 py-5">
              <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                <div className="flex min-w-0 items-center gap-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-cyan-500/15 text-xl">👤</div>
                  <div className="min-w-0">
                    <h2 className="truncate text-xl font-semibold text-white">
                      {selectedConversation.user?.firstname} {selectedConversation.user?.lastname}
                    </h2>
                    <div className="mt-1 flex flex-wrap items-center gap-2">
                      <p className="text-xs text-slate-500">Ticket #{selectedConversation.id}</p>
                      {unreadUserMessages.length > 0 && (
                        <span className="rounded-full bg-red-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-red-300">
                          {unreadUserMessages.length} non lu{unreadUserMessages.length > 1 ? "s" : ""}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap items-center gap-3">
                  <span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${
                    selectedConversation.status === "open"
                      ? "bg-emerald-500/10 text-emerald-300"
                      : "bg-slate-700 text-slate-300"
                  }`}>
                    {selectedConversation.status === "open" ? "Conversation ouverte" : "Conversation fermée"}
                  </span>
                  {selectedConversation.status === "open" ? (
                    <button onClick={() => handleUpdateStatus("closed")} disabled={updatingStatus}
                      className="rounded-xl bg-red-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-red-600 disabled:opacity-60">
                      {updatingStatus ? "Mise à jour..." : "Fermer le ticket"}
                    </button>
                  ) : (
                    <button onClick={() => handleUpdateStatus("open")} disabled={updatingStatus}
                      className="rounded-xl bg-emerald-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-emerald-600 disabled:opacity-60">
                      {updatingStatus ? "Mise à jour..." : "Rouvrir le ticket"}
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="flex-1 overflow-y-auto bg-slate-950/50 px-6 py-6">
              <div className="mx-auto flex max-w-4xl flex-col gap-4">
                {selectedConversation.messages?.length > 0 ? (
                  selectedConversation.messages.map((msg) => (
                    <MessageBubble key={msg.id} msg={msg} formatDateTime={formatDateTime} />
                  ))
                ) : (
                  <div className="rounded-2xl border border-slate-800 bg-slate-900 px-4 py-5 text-sm text-slate-400">
                    Aucun message dans cette conversation.
                  </div>
                )}
                <div ref={messagesEndRef} />
              </div>
            </div>

            <div className="border-t border-slate-800 bg-slate-900 px-6 py-5">
              {selectedConversation.status === "closed" && (
                <div className="mb-3 rounded-2xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm text-amber-300">
                  Ce ticket est fermé. Rouvrez-le pour envoyer une nouvelle réponse.
                </div>
              )}
              <textarea rows="4" value={reply} onChange={(e) => setReply(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSendReply(); }}}
                disabled={selectedConversation.status === "closed" || sending}
                placeholder={selectedConversation.status === "closed" ? "Ticket fermé" : "Écrire une réponse..."}
                className="w-full resize-none rounded-2xl border border-slate-700 bg-slate-950 px-4 py-3 text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-cyan-500 disabled:cursor-not-allowed disabled:opacity-60"
              />
              <div className="mt-3 flex justify-end">
                <button onClick={handleSendReply}
                  disabled={sending || !reply.trim() || selectedConversation.status === "closed"}
                  className="rounded-xl bg-cyan-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-cyan-500 disabled:opacity-60">
                  {sending ? "Envoi..." : "Envoyer la réponse"}
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className="flex flex-1 items-center justify-center px-6 text-center text-slate-400">
            Sélectionnez une conversation pour afficher les messages.
          </div>
        )}
      </div>
    </section>
  );
};

export default ConversationPanel;